export default {
  headerGeneral: 'Właściwości ogólne',
  headerSimulationValues: 'Wartości symulacyjne',
};
